export const checkboxInitals = {
    label: ["1st choice", "2nd choice", "3rd choice"],
};
